var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.338,
    height: 24.101,
    viewBox: "0 0 21.338 24.101",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18606",
    "data-name": "Group 18606",
    transform: "translate(-1234.328 -372.519)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "trash-can",
    transform: "translate(1235.328 373.519)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M32,96v15.885a2.072,2.072,0,0,0,2.072,2.072H46.5a2.072,2.072,0,0,0,2.072-2.072V96Z",
    transform: "translate(-30.619 -91.856)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M18.648,1.382H13.813l-.5-1A.691.691,0,0,0,12.7,0H6.643a.691.691,0,0,0-.618.382l-.5,1H.691A.691.691,0,0,0,0,2.073V3.454a.691.691,0,0,0,.691.691H18.648a.691.691,0,0,0,.691-.691V2.073A.691.691,0,0,0,18.648,1.382Z",
    transform: "translate(0 -0.001)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_42",
    "data-name": "Line 42",
    y2: 12.272,
    transform: "translate(6.601 7.239)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_43",
    "data-name": "Line 43",
    y2: 12.272,
    transform: "translate(9.669 7.239)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_44",
    "data-name": "Line 44",
    y2: 12.272,
    transform: "translate(12.737 7.239)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.8ecaef15454c2d2b318aff318fa53136.svg";
export { ForwardRef as ReactComponent };